import { getInitials } from "utils/helpers";

export default function TeamView({
    teamMembers,
    onClose,
}: {
    teamMembers: any;
    onClose: any;
}) {
    return (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-lg p-6 relative">
                {/* Close Button */}
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 text-gray-400 hover:text-gray-700 transition"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M6 18L18 6M6 6l12 12"
                        />
                    </svg>
                </button>

                {/* Header */}
                <h2 className="text-lg font-semibold text-gray-800 mb-5 border-b pb-3">
                    Team Members
                </h2>

                {/* List */}
                <div className="space-y-3 max-h-[60vh] overflow-y-auto pr-2 custom-scrollbar scrollbar-hide">
                    {teamMembers?.map((member: any) => {
                        const name =
                            member.name ||
                            member.prosecutor_name ||
                            member.user_name ||
                            member.full_name;

                        const roleLabel =
                            member?.role === "leader" || member?.is_team_leader
                                ? "Leader"
                                : "Member";

                        return (
                            <div
                                key={member.id}
                                className="flex items-center gap-3 bg-gray-50 border border-gray-200 rounded-lg p-3 hover:shadow-md transition"
                            >
                                {/* Avatar */}
                                <div className="w-10 h-10 rounded-full bg-gray-800 text-amber-400 flex items-center justify-center font-semibold text-sm select-none">
                                    {getInitials(name)}
                                </div>

                                {/* Info */}
                                <div className="flex-grow">
                                    <p className="font-medium text-gray-800">
                                        {name}
                                    </p>
                                    {!member.full_name && (
                                        <p className="text-xs text-gray-500">
                                            {(member?.role !== "leader" &&
                                                member?.role !== "member")
                                                ? member.role
                                                : "Prosecutor"}
                                        </p>
                                    )}
                                </div>

                                {/* Role Badge */}
                                <span
                                    className={`text-xs font-medium px-3 py-1 rounded-full border ${
                                        roleLabel === "Leader"
                                            ? "border-amber-500 text-amber-600"
                                            : "border-gray-300 text-gray-600"
                                    }`}
                                >
                                    {roleLabel}
                                </span>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}

